const supportTypo = {
  label: 'Archivos de soporte',
  noResults: 'Ningún resultado encontrado'
};

export default supportTypo;
